import Banner from "../components/currencyRate/Banner";
import CurrencyContent from "../components/currencyRate/CurrencyContent";

export default function CurrencyRate() {
    return (
        <>
            <Banner />
            <CurrencyContent />
        </>
    );
}
